export default {
    state: {
        exercise: {},
        error: '',
        headerCertificate: [],
    },
    actions: {
        SUBMIT_OPTION(context, payload) {
            const { exerciseId, questionId, answer } = payload;

            return window.axios
                .post(`/api/app/exercise/${exerciseId}/question/${questionId}/check`, {
                    answer,
                })
                .then(() => true)
                .catch((error) => {
                    console.error(error);
                    return false;
                });
        },

        SUBMIT_EXERCISE({ commit, state, dispatch }, payload) {
            var { id, slug, forced } = payload || {};
            if (!id) return Promise.resolve();
            var slug = {...slug, exercise: id};

            return window.axios
                .post(`/api/app/exercise/${id}/check`, {
                    slug,
                    forced: !!forced,
                })
                .then((res) => {
                    commit('SET_EXERCISE_SHOW_ANSWER', res.data.show_answer);
                    commit('SET_EXERCISE_PROGRESS', res.data.progress);
                    commit('SET_EXERCISE_GRADE', res.data.grade);
                    commit('SET_EXERCISE_GRADE_PERCENTAGE', res.data.grade_percentage);
                    commit('SET_EXERCISE_QUESTIONS', res.data.questions);
                    commit('SET_EXERCISE_FINISHED', res.data.finished);
                    commit('SET_EXERCISE_TRIES', res.data.tries);

                    dispatch('GET_CONTENT_PROGRESS');

                    if (state.exercise.started) {
                        commit('SET_EXERCISE_TIME_STARTED', {
                            started: false,
                            started_confirmation: true,
                        });
                    }
                })
                .catch((err) => {
                    commit('SET_ERROR', err.response.data.error);
                });
        },

        REDO_EXERCISE({ commit, dispatch }, payload) {
            return window.axios
                .get(`/api/app/exercise/${payload}/redo`)
                .then((res) => {
                    commit('SET_EXERCISE_SHOW_ANSWER', null);
                    commit('SET_EXERCISE_PROGRESS', null);
                    commit('SET_EXERCISE_GRADE', null);
                    commit('SET_EXERCISE_FINISHED', false);
                    commit('SET_EXERCISE_QUESTIONS', res.data.questions);

                    dispatch('GET_CONTENT_PROGRESS');
                })
                .catch((err) => {
                    commit('SET_ERROR', err.response.data.error);
                });
        },

        GET_EXERCISE_STUDENT_TIME({ commit, state, dispatch }) {
            return window.axios
                .get(`/api/app/exercise/${state.exercise.id}/time`)
                .then((res) => {
                    if (!res.data.student_time) {
                        return dispatch('SUBMIT_EXERCISE', { id: state.exercise.id, forced: true });
                    }

                    commit('SET_EXERCISE_STUDENT_TIME', res.data.student_time);
                    commit('SET_EXERCISE_TIME_STARTED', {
                        started: true,
                        started_confirmation: true,
                    });
                    return null;
                })
                .catch(err => console.error(err));
        },

        GET_EXERCISE_CERTIFICATE({ commit, dispatch }, payload) {
            return window.axios
                .get(`/app/certificate/exercise/${payload}`)
                .then((res) => {
                    commit('SET_EXERCISE_HEADER_CERTIFICATE', res.data.data.certificate
                        ? res.data.data.certificate.certificate
                        : null);
                    return res.data.data.certificate
                        ? res.data.data.certificate.certificate
                        : null;
                })
                .catch((err) => {
                    commit('SET_ERROR', err.response.data.error);
                });
        },
    },
    mutations: {
        SET_ERROR(state, payload) {
            state.error = payload;
        },
        CLEAR_ERROR(state) {
            state.error = '';
        },

        SET_EXERCISE(state, payload) {
            state.exercise = payload.exercise;
        },

        SET_EXERCISE_PROGRESS(state, payload) {
            state.exercise.progress = payload;
        },

        SET_EXERCISE_SHOW_ANSWER(state, payload) {
            state.exercise.show_answer = payload;
        },

        SET_EXERCISE_GRADE(state, payload) {
            state.exercise.grade = payload;
        },

        SET_EXERCISE_GRADE_PERCENTAGE(state, payload) {
            state.exercise.grade_percentage = payload;
        },

        SET_EXERCISE_QUESTIONS(state, payload) {
            state.exercise.questions = payload;
        },

        SET_EXERCISE_STUDENT_TIME(state, payload) {
            state.exercise = {
                ...state.exercise,
                student_time: payload,
            };
        },

        SET_EXERCISE_TIME_STARTED(state, payload) {
            state.exercise = {
                ...state.exercise,
                started: payload.started,
                started_confirmation: payload.started_confirmation,
            };
        },

        SET_EXERCISE_FINISHED(state, payload) {
            state.exercise.finished = payload;
        },

        SET_EXERCISE_TRIES(state, payload) {
            state.exercise.tries = payload;
        },

        SET_EXERCISE_HEADER_CERTIFICATE(state, payload) {
            state.headerCertificate.push(payload);
        },
    },
    getters: {
        LOADED_EXERCISE(state) {
            return state.exercise;
        },
        EXERCISE_ERROR(state) {
            return state.error;
        },
        LOADED_EXERCISE_HEADER_CERTIFICATE(state) {
            return state.headerCertificate;
        },
    },
};
